var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hold-request-tab"
  }, [_c('vue-element-loading', {
    attrs: {
      "active": _vm.isLoading || _vm.isSubmitting || _vm.isBulkUploading || _vm.isLoadingHistory,
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "sub-tab-bar"
  }, _vm._l((_vm.subTabs), function(tab) {
    return _c('button', {
      key: tab.key,
      class: ['tab-button', {
        active: _vm.currentSubTab === tab.key
      }],
      on: {
        "click": function($event) {
          return _vm.onSubTabSelect(tab.key)
        }
      }
    }, [_vm._v("\n          " + _vm._s(tab.value) + "\n        ")])
  }), 0), _vm._v(" "), (_vm.currentSubTab === 'upload') ? _c('div', {
    staticClass: "bulk-upload-panel"
  }, [_c('legend', {
    staticClass: "bulk-upload-title"
  }, [_vm._v("Bulk Hold Request Upload")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onBulkUploadSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row bulk-hold-scope-row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('label', {
    staticClass: "bulk-scope-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bulkHoldScope),
      expression: "bulkHoldScope"
    }],
    attrs: {
      "type": "radio",
      "name": "bulkHoldScope",
      "value": "cwb"
    },
    domProps: {
      "checked": _vm._q(_vm.bulkHoldScope, "cwb")
    },
    on: {
      "change": function($event) {
        _vm.bulkHoldScope = "cwb"
      }
    }
  }), _vm._v("\n                CWB hold\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "bulk-scope-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bulkHoldScope),
      expression: "bulkHoldScope"
    }],
    attrs: {
      "type": "radio",
      "name": "bulkHoldScope",
      "value": "holdAll"
    },
    domProps: {
      "checked": _vm._q(_vm.bulkHoldScope, "holdAll")
    },
    on: {
      "change": function($event) {
        _vm.bulkHoldScope = "holdAll"
      }
    }
  }), _vm._v("\n                Hold all\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    ref: "bulkFileInput",
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": _vm.onBulkFileChange
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.bulkParseError) ? _c('small', {
    staticClass: "text-danger d-block"
  }, [_vm._v(_vm._s(_vm.bulkParseError))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sample-link-wrap"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.downloadBulkSampleCsv.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download Hold Request Bulk Sample\n                ")])])]), _vm._v(" "), (_vm.bulkFailedResults.length) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Download Failed Rows")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-file-text'></i>"
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download Failed Rows"
    },
    on: {
      "click": _vm.exportBulkFailedRows
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "border": "0"
    }
  }, [_vm._v("Download\n                    "), _c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "margin-left": "10px",
      "font-size": "18px",
      "color": "red"
    }
  })])])])], 1) : _vm._e()]), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.bulkUploadSummary) ? _c('div', {
    staticClass: "upload-summary"
  }, [_c('div', {
    staticClass: "upload-summary-title"
  }, [_vm._v(_vm._s(_vm.bulkUploadSummary.message))]), _vm._v(" "), _c('div', {
    staticClass: "upload-summary-body"
  }, [_c('span', {
    staticClass: "upload-summary-chip"
  }, [_vm._v("Total: "), _c('strong', [_vm._v(_vm._s(_vm.bulkUploadSummary.totalRows))])]), _vm._v(" "), _c('span', {
    staticClass: "upload-summary-chip"
  }, [_vm._v("Raise: "), _c('strong', [_vm._v(_vm._s(_vm.bulkUploadSummary.raiseCount))])]), _vm._v(" "), _c('span', {
    staticClass: "upload-summary-chip"
  }, [_vm._v("Release: "), _c('strong', [_vm._v(_vm._s(_vm.bulkUploadSummary.releaseCount))])]), _vm._v(" "), _c('span', {
    staticClass: "upload-summary-chip valid"
  }, [_vm._v("Success: "), _c('strong', [_vm._v(_vm._s(_vm.bulkUploadSummary.successCount))])]), _vm._v(" "), _c('span', {
    staticClass: "upload-summary-chip"
  }, [_vm._v("Failed: "), _c('strong', [_vm._v(_vm._s(_vm.bulkUploadSummary.failureCount))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bulk-upload-actions"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "submit",
      "disabled": !_vm.bulkSelectedFile || !!_vm.bulkParseError || _vm.isBulkUploading
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Upload\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearBulkUploadForm
    }
  }, [_vm._v("\n              Clear\n            ")])])])]) : _vm._e(), _vm._v(" "), (_vm.currentSubTab === 'history') ? _c('div', {
    staticClass: "upload-history-panel"
  }, [_c('legend', {
    staticClass: "bulk-upload-title"
  }, [_vm._v("Bulk Hold Request Upload History")]), _vm._v(" "), (_vm.historyTotalRows > 0) ? _c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.uploadHistoryRows), function(file) {
    return _c('tr', {
      key: file.uploadFileId
    }, [_c('td', [_vm._v(_vm._s(file.filename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(file.uploadedBy))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatIst(file.uploadedAt)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(file.rowCount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(file.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatBulkUploadHoldType(file)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "fa fa-eye view-audit-icon",
      attrs: {
        "title": "View upload rows"
      },
      on: {
        "click": function($event) {
          return _vm.loadUploadAudit(file.uploadFileId)
        }
      }
    })])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.historyTotalRows > _vm.historyPageSize),
      expression: "historyTotalRows > historyPageSize"
    }],
    attrs: {
      "page-count": _vm.historyPageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getHistoryPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination upload-history-pagination'
    }
  }), _vm._v(" "), (!_vm.historyTotalRows) ? _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("No upload history found.")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.currentSubTab === 'upload') ? _c('div', {
    staticClass: "or-divider"
  }, [_c('span', [_vm._v("OR")])]) : _vm._e(), _vm._v(" "), (_vm.currentSubTab === 'upload') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("FM Parent Hub *")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Raise uses selected FM parent only (not in CSV above).")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.fmParentOptions,
      "selected-option": _vm.selectedFmParent,
      "placeholder": "Select FM parent hub"
    },
    on: {
      "select": _vm.onFmParentSelect
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.currentSubTab === 'upload' && !_vm.hasFmParents && !_vm.isLoading && !_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n        No FM parent hubs configured.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.currentSubTab === 'upload' && _vm.allOnHold) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n        All mapped LM hubs are currently on hold.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.currentSubTab === 'upload' && _vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n        "), _c('button', {
    staticClass: "btn btn-sm btn-outline-danger ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading || _vm.isSubmitting
    },
    on: {
      "click": function($event) {
        _vm.selectedFmParent.value ? _vm.loadLmHubsWithStatus(_vm.selectedFmParent.value) : _vm.loadFmParents()
      }
    }
  }, [_vm._v("\n          Retry\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentSubTab === 'upload' && _vm.lmRows.length) ? _c('div', {
    staticClass: "lm-table-wrap"
  }, [_c('table', {
    staticClass: "table table-bordered lm-hold-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.eligibleRows.length || _vm.isSubmitting
    },
    domProps: {
      "checked": _vm.allEligibleSelected
    },
    on: {
      "change": _vm.toggleSelectAllEligible
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "col-checkbox"
  }, [_vm._v("Hold all")]), _vm._v(" "), _c('th', [_vm._v("LM Hub")]), _vm._v(" "), _c('th', [_vm._v("Hold status")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.lmRows), function(row) {
    return _c('tr', {
      key: row.lmHubId
    }, [_c('td', {
      staticClass: "col-checkbox"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "disabled": !_vm.isRowSelectable(row) || _vm.isSubmitting
      },
      domProps: {
        "checked": !!_vm.selectedLmHubIds[row.lmHubId]
      },
      on: {
        "change": function($event) {
          return _vm.toggleRow(row.lmHubId)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "col-checkbox"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "disabled": !_vm.isRowSelectable(row) || _vm.isSubmitting || !_vm.selectedLmHubIds[row.lmHubId]
      },
      domProps: {
        "checked": !!_vm.lmHoldAllById[row.lmHubId]
      },
      on: {
        "change": function($event) {
          return _vm.toggleLmHoldAll(row.lmHubId)
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.lmHubName) + " (" + _vm._s(row.lmHubId) + ")")]), _vm._v(" "), _c('td', {
      class: _vm.rowStatusClass(row)
    }, [_c('div', [_vm._v(_vm._s(_vm.formatRowStatus(row)))]), _vm._v(" "), (row.latestRemark && !row.isOnHold) ? _c('div', {
      staticClass: "status-remark"
    }, [_c('strong', [_vm._v("Reason:")]), _vm._v(" " + _vm._s(row.latestRemark) + "\n                ")]) : _vm._e(), _vm._v(" "), (row.latestStatus === 'reject' && row.canRaiseHold && !row.submitError) ? _c('div', {
      staticClass: "status-hint text-muted"
    }, [_vm._v("\n                  If the configuration has been updated, select this hub and click\n                  "), _c('strong', [_vm._v("Raise Hold Request")]), _vm._v(" to try again.\n                ")]) : _vm._e(), _vm._v(" "), (row.submitMessage && row.submitError) ? _c('div', {
      staticClass: "status-submit-error"
    }, [_vm._v("\n                  " + _vm._s(row.submitMessage) + "\n                ")]) : _vm._e()])])
  }), 0)])]) : (_vm.currentSubTab === 'upload' && _vm.selectedFmParent.value && !_vm.isLoading && !_vm.errorMessage) ? _c('div', {
    staticClass: "empty-lm-message"
  }, [_vm._v("\n        No LM hubs mapped to this FM parent.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.currentSubTab === 'upload' && _vm.lmRows.length) ? _c('div', {
    staticClass: "submit-row"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.canSubmit
    },
    on: {
      "click": _vm.confirmBulkRaise
    }
  }, [_vm._v("\n          Raise Hold Request\n          "), (_vm.selectedEligibleCount) ? _c('span', [_vm._v(" (" + _vm._s(_vm.selectedEligibleCount) + ")")]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), (_vm.showUploadAuditModal) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "hide-footer": "",
      "title": "Upload Row Details"
    },
    model: {
      value: (_vm.showUploadAuditModal),
      callback: function($$v) {
        _vm.showUploadAuditModal = $$v
      },
      expression: "showUploadAuditModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Bulk Hold Request Upload Rows")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeUploadAuditModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm upload-audit-modal-body"
  }, [_c('vue-element-loading', {
    attrs: {
      "active": _vm.isLoadingUploadAudit,
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Row")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("LM Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("FM Parent")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("hold_status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bags Released")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Message")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Remarks")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.uploadAuditRows), function(audit) {
    return _c('tr', {
      key: audit.auditId || audit.csvRowNumber
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(audit.csvRowNumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(audit.lmHubName) + " (" + _vm._s(audit.lmHubId) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(audit.fmParentHubName) ? _c('span', [_vm._v(_vm._s(audit.fmParentHubName) + " (" + _vm._s(audit.fmParentHubId) + ")")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(audit.action))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(audit.holdStatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(audit.requestStatus || '-'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatReleasedBagCount(audit)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(audit.resultMessage))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(audit.isHoldAll ? "Hold All" : "Cwb"))])])
  }), _vm._v(" "), (!_vm.uploadAuditRows.length && !_vm.isLoadingUploadAudit) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.auditTotalRows > _vm.auditPageSize),
      expression: "auditTotalRows > auditPageSize"
    }],
    attrs: {
      "page-count": _vm.auditPageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getAuditPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination upload-audit-pagination'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeUploadAuditModal
    }
  }, [_vm._v("Close")])])])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "sm",
      "hide-footer": "",
      "centered": ""
    },
    model: {
      value: (_vm.showConfirmModal),
      callback: function($$v) {
        _vm.showConfirmModal = $$v
      },
      expression: "showConfirmModal"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onConfirmCancel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.confirmMessage))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": _vm.onConfirmProceed
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    staticStyle: {
      "margin-left": "5px"
    },
    on: {
      "click": _vm.onConfirmCancel
    }
  }, [_vm._v("Cancel")])])])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "d-block"
  }, [_vm._v("Hold scope "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Hold Request Bulk File "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', {
    staticClass: "text-muted"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Only .csv files. Max 5 MB. Max 200 rows.")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "expected-column"
  }, [_c('div', {
    staticClass: "expected-title"
  }, [_vm._v("Expected columns:")]), _vm._v(" "), _c('div', {
    staticClass: "column-tags"
  }, [_c('span', {
    staticClass: "column-tag mandatory"
  }, [_vm._v("LM Hub ID")]), _vm._v(" "), _c('span', {
    staticClass: "column-tag mandatory"
  }, [_vm._v("LM Hub Name")]), _vm._v(" "), _c('span', {
    staticClass: "column-tag mandatory"
  }, [_vm._v("FM Parent Hub ID")]), _vm._v(" "), _c('span', {
    staticClass: "column-tag mandatory"
  }, [_vm._v("FM Parent Hub Name")]), _vm._v(" "), _c('span', {
    staticClass: "column-tag mandatory"
  }, [_vm._v("Hold Status")])]), _vm._v(" "), _c('div', {
    staticClass: "layout-note"
  }, [_vm._v("\n              FM parent must match LM–FM mapping. hold_status "), _c('strong', [_vm._v("true")]), _vm._v(" raises hold;\n              "), _c('strong', [_vm._v("false")]), _vm._v(" releases hold for that FM parent. Same LM may appear with different parents.\n              Rows are processed sequentially.\n            ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("File Name")]), _vm._v(" "), _c('th', [_vm._v("Uploaded By")]), _vm._v(" "), _c('th', [_vm._v("Uploaded At (IST)")]), _vm._v(" "), _c('th', [_vm._v("Rows")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Hold Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("View")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45bab192","hasScoped":true}!./src/views/components/CwbHoldRequest/HoldRequestTab/HoldRequestTab.html
// module id = 1108
// module chunks = 2